<template>
  <div>
    <el-upload
      class="upload-demo"
      ref="uploadRef"
      action=""
      :before-upload="beforeAvatarUpload"
      :on-remove="handleRemove"
      multiple
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :http-request="httpRequestBack"
      :auto-upload="true"
      :on-preview="(file) => handlePreview(file)"
    >
      <el-button
        size="small"
        type="primary"
        icon="el-icon-upload"
        :loading="loading"
      >
        点击上传</el-button
      >
      <!-- 自定义文件列表 - 保留默认的删除和预览功能 -->
      <div slot="file" slot-scope="{ file }">
        <div class="custom-file-item">
          <span class="el-icon-document"></span>
          <span
            class="el-upload-list__item-name"
            @click="handlePreview(file)"
            >{{ file.name }}</span
          >
          <el-button
            v-if="showBindStep"
            type="text"
            size="mini"
            class="file-action-btn"
            :class="{
              yellow: file.flowList && file.flowList.length > 0,
            }"
            @click="handleFileAction(file)"
          >
            {{
              file.flowList && file.flowList.length > 0
                ? "指定环节可见"
                : "选择查看环节"
            }}
          </el-button>
          <el-button
            type="text"
            size="mini"
            class="el-icon-close"
            @click="handleRemove(file, fileList)"
          ></el-button>
        </div>
      </div>
    </el-upload>
    <!-- 预览文件 -->
    <VueOfficeView
      ref="fileView"
      :fileType="fileType"
      :fileUrl="fileUrl"
      :fileName="fileName"
    ></VueOfficeView>
  </div>
</template>

<script>
import { mixinPreview } from "@/mixins/filepreview.js";
import { getStorage } from "@/storage";
export default {
  name: "Uploadfile",
  mixins: [mixinPreview],
  props: {
    limit: {
      type: Number,
      default: 6,
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showBindStep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: getStorage("token"),
      files: [],
    };
  },
  methods: {
    // 图片上传之前
    beforeAvatarUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt50M;
    },
    handleRemove(file, fileList) {
      fileList.map((v, i) => {
        if (file.uid === v.uid) {
          fileList.splice(i, 1);
        }
      });
      this.files = [];
      this.$emit("setfileList", fileList);
    },
    httpRequestBack(file) {
      var formData = new FormData();
      formData.append("file[]", file.file);
      this.$emit("update:loading", true);
      // 上传文件
      this.$http
        .post("/common/qiniu/uploadFilePatch", { formData, type: "upload" })
        .then((res) => {
          console.log(res.code, "res.code");
          if (res.code == 1) {
            let str = {
              name: res.data[0].name,
              url: res.data[0].all_path_url,
            };
            // this.files.push(str);
            this.$emit("setfileList", [...this.fileList, str]);
          }
        })
        .finally(() => {
          this.$emit("update:loading", false);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`附件限制选择 ${this.limit} 个文件`);
      return;
    },
    handleFileAction(file) {
      this.$emit("file-action", file);
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.imgWrap ::v-deep .avatar-uploader-icon {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.upload-demo ::v-deep .el-upload-list {
  width: 100%;
}
.upload-demo ::v-deep .el-upload-list__item {
  width: 100%;
  margin-top: 5px;
}
.custom-file-item {
  display: flex;
  align-items: center;
  padding: 0 10px;
  width: 100%;
}
.custom-file-item .el-icon-document {
  color: #909399;
  margin-right: 7px;
}
.custom-file-item .el-upload-list__item-name {
  color: #606266;
  margin-right: auto;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.custom-file-item .el-upload-list__item-name:hover {
  color: #409eff;
}
.file-action-btn {
  margin-right: 18px;
  color: #409eff;
}
.custom-file-item .el-icon-close {
  color: #909399;
  cursor: pointer;
}
.custom-file-item .el-icon-close:hover {
  color: #f56c6c;
}
.custom-file-item .el-icon-close {
  top: 0px !important;
}
.yellow {
  color: #e6a23c;
}
</style>